module.exports = __webpack_public_path__ + "static/media/arrow-left.5a3b027b.svg";